export const API_URLS = {
	business: {
		getTokenUrl: "/Auth/get-token",
	},
	customer: {
		registerUrl: "/Auth/register",
		updateUrl: "/User/Update",
		forgotPasswordUrl: "/Auth/generate-token",
		loginUrl: "/Auth/login",
		logInWithGoogleUrl: "/Auth/google-auth",
		validateTokenUrl: "/Auth/validate-token",
		updatePassword: "/Auth/update-password",
	},
	days: {
		daysOfflineUrl: "/NotAvailableDate/full-disabled-dates",
		daysOfflineByServiceUrl: "/NotAvailableDate/full-disabled-dates-by-service",
		servicesDaysOfflineUrl:
			"/ServiceAvailabilityException/get-fully-disabled-dates",
	},
	payment: {
		getPreferencesUrl: "/Payments/create-preference",
		processPaymentUrl: "/Payments/process",
		getPaymentStatusUrl: "/Payments/check-status/{externalReference}",
	},
	reservation: {
		findTableUrl: "/Search/search-table",
		getByCustomerUrl: "/Reservation/customer/{id}/items",
		getByPaymentUrl: "/Reservation/get-by-payment?paymentId={id}",
		saveUrl: "/Reservation/client/create",
		cancelUrl: "/Reservation/cancel/{id}",
	},
	service: {
		getAllUrl: "/Service/available-services",
	},
};
